// src/components/AddActivityForm.js
import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp, query, onSnapshot } from 'firebase/firestore';

const daysOfWeek = [
  "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"
];

const AddActivityForm = ({ onClose }) => {
  const [activity, setActivity] = useState('');
  const [day, setDay] = useState('');
  const [time, setTime] = useState('');
  const [error, setError] = useState('');
  const [users, setUsers] = useState([]);
  const [assignedTo, setAssignedTo] = useState('');

  useEffect(() => {
    const q = query(collection(db, 'users'));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const usersData = [];
      querySnapshot.forEach((doc) => {
        usersData.push({ id: doc.id, ...doc.data() });
      });
      setUsers(usersData);
    });
    return () => unsubscribe();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!activity.trim() || !day || !assignedTo || !time) {
      setError('Please fill out all fields.');
      return;
    }

    try {
      // NEW: Logic to handle "ALL" vs specific user
      let nicknameToSave = "Everyone"; // Default for 'ALL'
      
      if (assignedTo !== "ALL") {
        const assignedUser = users.find(u => u.id === assignedTo);
        nicknameToSave = assignedUser.nickname || assignedUser.email;
      }

      await addDoc(collection(db, 'activities'), {
        name: activity,
        day: day,
        time: time,
        createdAt: serverTimestamp(),
        assignedTo: assignedTo, // Will be user ID or "ALL"
        assignedUserNickname: nicknameToSave
      });

      setActivity('');
      setDay('');
      setTime('');
      setAssignedTo('');
      setError('');
      onClose();
    } catch (err) {
      setError('Failed to add activity.');
      console.error(err);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit} className="add-chore-form">
        <input
          type="text"
          value={activity}
          onChange={(e) => setActivity(e.target.value)}
          placeholder="e.g., Movie Night"
        />

        <select value={assignedTo} onChange={(e) => setAssignedTo(e.target.value)}>
          <option value="" disabled>Assign to...</option>
          
          {/* NEW: The "All" Option */}
          <option value="ALL">All (Everyone)</option>
          <option disabled>──────────</option>

          {users.map((user) => (
            <option key={user.id} value={user.id}>
              {user.nickname || user.email}
            </option>
          ))}
        </select>
        
        <select value={day} onChange={(e) => setDay(e.target.value)}>
          <option value="" disabled>Select day...</option>
          {daysOfWeek.map((d) => (
            <option key={d} value={d}>
              {d}
            </option>
          ))}
        </select>

        <input
          type="time"
          value={time}
          onChange={(e) => setTime(e.target.value)}
          className="time-input"
        />

        <button type="submit">Add Activity</button>
      </form>
      {error && <p className="error-message">{error}</p>}
    </>
  );
};

export default AddActivityForm;